/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Subscription type describes the type of subscription the asset has, for example Economy, Standard or Premium.
 *
 */
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["PREMIUM"] = "Premium";
    SubscriptionType["STANDARD"] = "Standard";
    SubscriptionType["ECONOMY"] = "Economy";
})(SubscriptionType || (SubscriptionType = {}));
